module.exports = "/assets/data/6b6a840350c618a885958fff942e6159-GU6.data.json";